module.exports = __webpack_public_path__ + "img/产品中心 条幅1.18200db9.jpg";